// extracted by mini-css-extract-plugin
export default {"App":"App_App__KQ3na","App-logo":"App_App-logo__-8iov","App-logo-spin":"App_App-logo-spin__rbLH+","App-header":"App_App-header__3TAU3","App-link":"App_App-link__RIdlP"};